var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f6f7",
    d: "M421.667 7.501H90.333c-11.158 0-20.203 9.045-20.203 20.203v456.593c0 11.162 9.041 20.203 20.203 20.203h331.333c11.162 0 20.203-9.041 20.203-20.203V27.704c.001-11.158-9.044-20.203-20.202-20.203z",
    opacity: 1,
    "data-original": "#f1f6f7",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deecf1",
    d: "M421.667 7.501h-32.325c11.158 0 20.203 9.045 20.203 20.203v456.593c0 11.162-9.041 20.203-20.203 20.203h32.325c11.162 0 20.203-9.041 20.203-20.203V27.704c0-11.158-9.045-20.203-20.203-20.203z",
    opacity: 1,
    "data-original": "#deecf1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd064",
    d: "M334.793 298.427c-31.656 0-58.696 19.687-69.596 47.478H122.659l-20.203 27.274 20.203 27.274h15.307l12.881-12.882 12.882 12.882h11.556l12.953-12.953 12.953 12.953h64.007c10.9 27.79 37.94 47.478 69.596 47.478 41.284 0 74.752-33.468 74.752-74.752s-33.469-74.752-74.753-74.752zm34.758 88.895c0 8.926-7.236 16.163-16.163 16.163-8.926 0-16.163-7.236-16.163-16.163v-28.285c0-8.926 7.236-16.163 16.163-16.163 8.926 0 16.163 7.236 16.163 16.163zM182.258 291.356l-24.244-10.101-24.244 10.101v-64.65h48.488z",
    opacity: 1,
    "data-original": "#ffd064"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc250",
    d: "M133.77 257.384c7.664 2.382 15.807 3.668 24.244 3.668s16.58-1.285 24.244-3.668v-30.678H133.77z",
    opacity: 1,
    "data-original": "#ffc250"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.014,
    cy: 183.269,
    r: 55.559,
    fill: "#a2f5c3",
    opacity: 1,
    "data-original": "#a2f5c3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88f2a9",
    d: "M189.817 137.724a55.284 55.284 0 0 1 10.014 31.802c0 30.684-24.875 55.559-55.559 55.559a55.284 55.284 0 0 1-31.802-10.014c10.045 14.358 26.692 23.757 45.545 23.757 30.684 0 55.559-24.875 55.559-55.559-.001-18.853-9.399-35.501-23.757-45.545z",
    opacity: 1,
    "data-original": "#88f2a9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e175a5",
    d: "M357.016 39.825V72.15H154.983V39.825z",
    opacity: 1,
    "data-original": "#e175a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.67 0H90.33c-15.274 0-27.7 12.426-27.7 27.699v375.78c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5V27.699C77.63 20.697 83.327 15 90.33 15h331.34c7.003 0 12.7 5.697 12.7 12.699v52.37c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-52.37C449.37 12.426 436.945 0 421.67 0zM441.87 107.57a7.499 7.499 0 0 0-7.5 7.5V484.3c0 7.003-5.697 12.7-12.7 12.7H90.33c-7.003 0-12.7-5.697-12.7-12.7v-45.82c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v45.82c0 15.274 12.426 27.7 27.7 27.7h331.34c15.274 0 27.7-12.426 27.7-27.7V115.07c0-4.143-3.357-7.5-7.5-7.5z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.388 410.984c13.048 0 23.663-10.615 23.663-23.662v-28.285c0-13.047-10.615-23.662-23.663-23.662-13.047 0-23.662 10.615-23.662 23.662v28.285c0 13.047 10.615 23.662 23.662 23.662zm-8.662-51.947c0-4.776 3.886-8.662 8.662-8.662 4.777 0 8.663 3.886 8.663 8.662v28.285c0 4.776-3.886 8.662-8.663 8.662-4.776 0-8.662-3.886-8.662-8.662z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.26 353.41c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-62.6a7.498 7.498 0 0 0-6.026 3.036l-20.2 27.27a7.498 7.498 0 0 0 0 8.928l20.2 27.271a7.498 7.498 0 0 0 6.026 3.036h15.311c1.989 0 3.896-.79 5.304-2.197l7.576-7.576 7.576 7.576a7.5 7.5 0 0 0 5.304 2.197h11.55a7.504 7.504 0 0 0 5.302-2.194l7.656-7.651 7.648 7.649a7.502 7.502 0 0 0 5.304 2.196h59.068c6.143 13.174 15.632 24.448 27.674 32.819 13.798 9.591 30.001 14.66 46.858 14.66 45.353 0 82.25-36.898 82.25-82.25s-36.898-82.25-82.25-82.25c-16.856 0-33.06 5.069-46.858 14.661-12.042 8.37-21.531 19.646-27.674 32.819H220.26c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h44.94a7.501 7.501 0 0 0 6.982-4.762c10.178-25.95 34.753-42.719 62.608-42.719 37.082 0 67.25 30.168 67.25 67.25s-30.168 67.25-67.25 67.25c-27.855 0-52.43-16.768-62.608-42.718a7.501 7.501 0 0 0-6.982-4.762h-60.903l-10.753-10.754a7.502 7.502 0 0 0-10.605-.002l-10.763 10.756h-5.339l-10.683-10.684a7.5 7.5 0 0 0-10.608 0l-10.683 10.684h-8.426l-14.645-19.771 14.645-19.77h58.823z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.421 397.424v-48.488c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v48.488c0 4.143 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5zM94.956 183.269c0 23.2 12.604 43.501 31.315 54.452v53.635a7.497 7.497 0 0 0 7.501 7.5c.976 0 1.956-.19 2.884-.577l21.359-8.899 21.358 8.899a7.501 7.501 0 0 0 10.385-6.923v-53.634c18.711-10.95 31.315-31.251 31.315-54.452 0-34.771-28.288-63.059-63.059-63.059s-63.058 28.287-63.058 63.058zm79.802 96.836-13.858-5.774a7.495 7.495 0 0 0-5.77 0l-13.859 5.774v-36.052c5.336 1.472 10.947 2.274 16.744 2.274s11.407-.802 16.743-2.274zM158.014 135.21c26.5 0 48.059 21.559 48.059 48.059s-21.559 48.059-48.059 48.059-48.059-21.559-48.059-48.059 21.559-48.059 48.059-48.059z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.014 214.002c8.202 0 15.918-3.199 21.726-9.009a7.498 7.498 0 0 0-.001-10.606 7.498 7.498 0 0 0-10.606.001 15.622 15.622 0 0 1-11.118 4.614c-8.676 0-15.734-7.058-15.734-15.733s7.059-15.733 15.734-15.733c4.194 0 8.144 1.639 11.118 4.614a7.5 7.5 0 0 0 10.606.001 7.498 7.498 0 0 0 .001-10.606c-5.808-5.81-13.523-9.009-21.726-9.009-16.947 0-30.734 13.787-30.734 30.733s13.787 30.733 30.734 30.733zM409.544 184.861H251.959c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h157.585c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5zM409.544 120.21H292.366c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h117.178c4.143 0 7.5-3.357 7.5-7.5a7.5 7.5 0 0 0-7.5-7.5zM409.544 152.535H251.959c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h157.585c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5zM273.708 232.185c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-21.749c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5zM359.036 232.185c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-53.003c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5zM357.016 32.325H154.984a7.499 7.499 0 0 0-7.5 7.5V72.15c0 4.143 3.357 7.5 7.5 7.5h202.032c4.143 0 7.5-3.357 7.5-7.5V39.825a7.5 7.5 0 0 0-7.5-7.5zm-7.5 32.326H162.484V47.325h187.032z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermission);
export default __webpack_public_path__ + "static/media/permission.b842e4714562b69675e6a79ed3269637.svg";
export { ForwardRef as ReactComponent };